import { styled } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const PREFIX = 'Header';

const classes = {
  title: `${PREFIX}-title`,
  description: `${PREFIX}-description`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.title}`]: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 0 0.5rem 0',
    color: theme.colorTokens.onSurfaceTextHeadline,
    fontWeight: 600,
    textDecoration: 'underline',
  },

  [`& .${classes.description}`]: {
    marginTop: 0,
    fontSize: '14px',
    lineHeight: '1.5rem',
    color: theme.colorTokens.onSurfaceTextBody,
  },
}));

export const Header = () => {
  return (
    <Root>
      <h3 className={classes.title}>
        Delivery Details <ArrowDropDownIcon />
      </h3>
      <p className={classes.description}>
        While Jitsu will attempt to complete your delivery change requests, you will not be able to update the scheduled delivery date.
      </p>
    </Root>
  );
};
